<div class="container-fluid">
  <div class="row my-3">
    <div class="col-6">
      <div class="fixHeight">
        <div *ngIf="interventions.length > 0; then thenShowInterventionsInStudy else elseShowNoInterventionsInStudy"></div>
        <ng-template #thenShowInterventionsInStudy>
          <p><strong>{{ 'codebook.available_interventions' | translate }}:</strong></p>
          <mat-form-field class="full-width">
            <mat-label>{{ 'codebook.selected_intervention' | translate }}</mat-label>
            <mat-select
              (selectionChange)="getQuestionnairesOfIntervention($event.value.id)"
              [id]="'selectionIntervention'"
              (click)="resetInterventionFilter()"
              [compareWith]="idEquals"
              [(ngModel)]="selectedIntervention"
            >
              <mat-form-field *ngIf="interventions.length > 1" class="full-width" appearance="fill">
                <mat-label>{{ 'codebook.filter_intervention' | translate }}</mat-label>
                <input
                  [id]="'interventionSelection'"
                  autocomplete="off"
                  matInput
                  (keyup)="handleInterventionFilter()"
                  [(ngModel)]="filter.interventionSelection"
                />
              </mat-form-field>
              <mat-option
                *ngFor="let intervention of (interventions$ | async)"
                [id]="'intervention_option_' + intervention.id"
                [value]="intervention"
              >
                {{ getDropdownName(intervention) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
        <ng-template #elseShowNoInterventionsInStudy>
          <p><strong>{{ 'codebook.no_intervention_study' | translate }}</strong></p>
        </ng-template>
      </div>
    </div>

    <div class="col-6">
      <div class="fixHeight">
        <div *ngIf="diaries.length > 0; then thenShowDiariesInStudy else elseShowNoDiariesInStudy"></div>
        <ng-template #thenShowDiariesInStudy>
          <p><strong>{{ 'codebook.available_diaries' | translate }}:</strong></p>
          <mat-form-field class="full-width">
            <mat-label>{{ 'codebook.selected_diary' | translate }}</mat-label>
            <mat-select
              (selectionChange)="getQuestionnaireOfDiary($event.value.id)"
              [id]="'selectionDiary'"
              (click)="resetDiaryFilter()"
              [compareWith]="idEquals"
              [(ngModel)]="selectedDiary"
            >
              <mat-form-field *ngIf="diaries.length > 1" class="full-width" appearance="fill">
                <mat-label>{{ 'codebook.filter_diary' | translate }}</mat-label>
                <input
                  [id]="'diarySelection'"
                  autocomplete="off"
                  matInput
                  (keyup)="handleDiaryFilter()"
                  [(ngModel)]="filter.diarySelection"
                />
              </mat-form-field>
              <mat-option
                *ngFor="let diary of (diaries$ | async)"
                [id]="'diary_option_' + diary.id"
                [value]="diary"
              >
                {{ getDropdownName(diary) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
        <ng-template #elseShowNoDiariesInStudy>
          <p><strong>{{ 'codebook.no_diary_study' | translate }}</strong></p>
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngIf="selectedIntervention" class="mx-2 mb-4">
    <div class="row mx-2 mb-4">
      <img
        class="col-4"
        [src]="helper.getAllMediaSupportPath(selectedIntervention.attributes.picture, study.id)"
        (error)="helper.getFallbackImage($event)"
        alt="No image"
        class="image-parent img-fluid"
      />
      <div class="col-8">
        <p>
          <strong>{{ selectedIntervention.attributes.title || ('codebook.no_title' | translate) }}</strong>
        </p>
        <p>
          <small class="text-muted">({{ selectedIntervention.attributes.name }}) (ID - {{ selectedIntervention.id }})</small>
        </p>
      </div>
    </div>

    <mat-form-field>
      <mat-label>{{ 'codebook.selected_language' | translate }}</mat-label>
      <mat-select
        [attr.id]="'selectedLanguage'"
        [(ngModel)]="selectedLanguage"
        [disabled]="!selectedQuestionnaire"
      >
        <mat-option
          [attr.id]="'option_' + language"
          *ngFor="let language of languages"
          [value]="language"
        >
          {{ language }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button (click)="exportInterventionCodebook(selectedIntervention.id)" class="exportButton" mat-stroked-button>
      {{ 'codebook.export_intervention_codebook' | translate }}
    </button>
  </div>

  <div *ngIf="selectedDiary" class="mx-2 mb-4">
    <div class="row mx-2 mb-4">
      <img
        class="col-4"
        [src]="helper.getAllMediaSupportPath(selectedDiary.attributes.picture, study.id)"
        (error)="helper.getFallbackImage($event)"
        alt="No image"
        class="image-parent img-fluid"
      />
      <div class="col-8">
        <p>
          <strong>{{ selectedDiary.attributes.title || ('codebook.no_title' | translate) }}</strong>
        </p>
        <p><small class="text-muted">({{ selectedDiary.attributes.name }}) (ID - {{ selectedDiary.id }})</small></p>
      </div>
    </div>

    <mat-form-field>
      <mat-label>{{ 'codebook.selected_language' | translate }}</mat-label>
      <mat-select
        [attr.id]="'selectedLanguage'"
        [(ngModel)]="selectedLanguage"
        [disabled]="!selectedQuestionnaire"
      >
        <mat-option
          [attr.id]="'option_' + language"
          *ngFor="let language of languages"
          [value]="language"
        >
          {{ language }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button (click)="exportDiaryCodebook(selectedDiary.id)" class="exportButton" mat-stroked-button>
      {{ 'codebook.export_diary_codebook' | translate }}
    </button>
  </div>

  <div *ngIf="interventions.length > 0 || diaries.length > 0">
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ 'codebook.selected_questionnaire' | translate }}</mat-label>
          <mat-select
            [disabled]="!selectedQuestionnaire"
            (selectionChange)="changeSelection()"
            [attr.id]="'selectionQuestionnaire'"
            (click)="resetQuestionnaireFilter()"
            [compareWith]="idEquals"
            [(ngModel)]="selectedQuestionnaire"
          >
            <mat-form-field *ngIf="questionnaires.length > 1" class="full-width" appearance="fill">
              <mat-label>{{ 'codebook.filter_lesson' | translate }}</mat-label>
              <input
                [attr.id]="'questionnaireSelection'"
                autocomplete="off"
                matInput
                (keyup)="handleQuestionnaireFilter()"
                [(ngModel)]="filter.questionnaireSelection"
              />
            </mat-form-field>
            <mat-option
              [attr.id]="'option_' + questionnaire?.id"
              *ngFor="let questionnaire of (questionnaires$ | async)"
              [value]="questionnaire"
            >
              {{ getDropdownName(questionnaire) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        *ngIf="selectedQuestionnaire && questionnaireElements.length === 0"
        style="text-align: center;"
      >
        <strong>{{ 'codebook.no_questions' | translate }}</strong>
      </div>
      <div class="mat-elevation-z0 text-start mb-3" *ngIf="questionnaireElements.length > 0">
        <table [dataSource]="dataSource" mat-table>
          <ng-container matColumnDef="position">
            <th *matHeaderCellDef mat-header-cell>{{ 'codebook.position' | translate }}</th>
            <td *matCellDef="let element" mat-cell>{{ element.position }}</td>
          </ng-container>
          <ng-container matColumnDef="questionType">
            <th *matHeaderCellDef mat-header-cell>{{ 'codebook.questiontype' | translate }}</th>
            <td *matCellDef="let element" mat-cell>{{ 'codebook.' + element.questiontype.toLowerCase() | translate }}</td>
          </ng-container>
          <ng-container matColumnDef="questionLabel">
            <th *matHeaderCellDef mat-header-cell>{{ 'codebook.questionlabel' | translate }}</th>
            <td *matCellDef="let element" mat-cell>{{ element.label.toLowerCase() }}</td>
          </ng-container>
          <ng-container matColumnDef="question">
            <th *matHeaderCellDef mat-header-cell>{{ 'codebook.question' | translate }}</th>
            <td *matCellDef="let element" mat-cell>{{ getCodebookQuestion(element.translations) }}</td>
          </ng-container>
          <ng-container matColumnDef="answer">
            <th *matHeaderCellDef mat-header-cell>{{ 'codebook.answer' | translate }}</th>
            <td *matCellDef="let element" mat-cell>{{ getCodebookAnswer(element) | async }}</td>
          </ng-container>
          <ng-container matColumnDef="raw">
            <th *matHeaderCellDef mat-header-cell>{{ 'codebook.raw_data' | translate }}</th>
            <td *matCellDef="let element" mat-cell>{{ getCodebookRawAnswer(element) }}</td>
          </ng-container>
          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>
      </div>
    </div>
  </div>
</div>
